var _path, _path2, _g, _path3, _path4, _path5, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSavedIcon = function SvgSavedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 21a1 1 0 0 1-1-1V5.333C5.5 4.047 6.487 3 7.7 3h9.6c1.213 0 2.2 1.047 2.2 2.333V20a1.001 1.001 0 0 1-1.492.871l-5.672-3.208-5.321 3.194A1.004 1.004 0 0 1 6.5 21",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "SavedIcon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 15,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 21a1 1 0 0 1-1-1V5.333C5.5 4.047 6.487 3 7.7 3h9.6c1.213 0 2.2 1.047 2.2 2.333V20a1.001 1.001 0 0 1-1.492.871l-5.672-3.208-5.321 3.194A1.004 1.004 0 0 1 6.5 21",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#SavedIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#101010",
    d: "M.5 0h24v24H.5z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1a5 5 0 1 0 0 10 5 5 0 0 0 0-10",
    stroke: "#fff",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.648 4.803-2.284 3a.5.5 0 0 1-.395.197h-.003a.5.5 0 0 1-.394-.192l-1.216-1.553a.5.5 0 1 1 .788-.616l.816 1.043 1.892-2.485a.5.5 0 0 1 .796.606",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "SavedIcon_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 11,
    height: 11
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.648 4.803-2.284 3a.5.5 0 0 1-.395.197h-.003a.5.5 0 0 1-.394-.192l-1.216-1.553a.5.5 0 1 1 .788-.616l.816 1.043 1.892-2.485a.5.5 0 0 1 .796.606ZM16.5 1a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#SavedIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.5 0h12v12h-12z"
  }))));
};
export default SvgSavedIcon;